module.exports = "/static/assets/1338197c2aeb708ee8c324f6f2374835.png";